import { useRef, useState } from 'react';
import { contentService } from '../../../services';

export default function useEditImageDomain() {
  const [editBaseImage, setEditBaseImage] = useState(null);
  const [editMaskImage, setEditMaskImage] = useState(null);
  const [editPrompt, setEditPrompt] = useState('');
  const [editMode, setEditMode] = useState('EDIT_MODE_INPAINT_INSERTION');
  const [brushSize, setBrushSize] = useState(20);
  const [isDrawing, setIsDrawing] = useState(false);
  const [editedImage, setEditedImage] = useState(null);
  const [isEditing, setIsEditing] = useState(false);

  const canvasRef = useRef(null);
  const maskCanvasRef = useRef(null);

  const runEdit = async () => {
    if (!editBaseImage || !editPrompt.trim()) return;

    try {
      setIsEditing(true);
      const maskData = maskCanvasRef.current?.toDataURL()?.split(',')[1] || '';
      const baseData = editBaseImage?.split(',')[1] || '';

      const data = await contentService.editImage({
        image: baseData,
        mask: maskData,
        prompt: editPrompt,
        mode: editMode
      });

      if (data.success) {
        setEditedImage(data.image_url || data.image_base64 || null);
      }
    } catch (error) {
      console.error('Erro ao editar imagem:', error);
    } finally {
      setIsEditing(false);
    }
  };

  return {
    editBaseImage,
    setEditBaseImage,
    editMaskImage,
    setEditMaskImage,
    editPrompt,
    setEditPrompt,
    editMode,
    setEditMode,
    brushSize,
    setBrushSize,
    isDrawing,
    setIsDrawing,
    canvasRef,
    maskCanvasRef,
    editedImage,
    isEditing,
    runEdit
  };
}
